import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const ToastService = {
  success(message, options = {}) {
    toast.success(message, { ...options, autoClose: 3000, position: "top-right" });
  },
  error(message, options = {}) {
    toast.error(message, { ...options, autoClose: 3000, position: "top-right" });
  },
  info(message, options = {}) {
    toast.info(message, { ...options, autoClose: 3000, position: "top-right" });
  },
  warning(message, options = {}) {
    toast.warning(message, { ...options, autoClose: 3000, position: "top-right" });
  },
  custom(message, options = {}) {
    toast(message, { ...options });
  }
};

export default ToastService;
